import { FieldArray } from 'formik'
import Break from './Break'

const Breaks = () => <FieldArray name='BreakTimes.Times' render={({ push, remove }) => <Break push={push} remove={remove} />} />

export default Breaks
